import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

export interface TabCardProps {
  id: string;
  title: string;
  subtitle?: string;
  bodies?: {
    prefix: string;
    suffix: string;
  }[];
  bulletHeading: string;
  bullets?: {
    prefix: string;
    suffix: string;
  }[];
}

export function TabCard({
  id,
  title,
  subtitle,
  bodies,
  bulletHeading,
  bullets,
}: TabCardProps) {
  return (
    <Stack
      sx={{
        alignItems: "flex-start",
        justifySelf: "center",
        textAlign: "left",
        width: { sm: 312, lg: 564 },
      }}
    >
      <Typography
        display="block"
        sx={{
          mb: 3,
          textAlign: "left",
        }}
        variant="subtitle2"
      >
        {title}
      </Typography>

      <Typography
        display="block"
        mb={3}
        variant="body1"
        width={{ sm: 312, lg: 516 }}
      >
        {subtitle}
      </Typography>

      {bodies && (
        <Stack
          sx={{
            maxWidth: 600,
            textAlign: "left",
            width: { sm: 312, lg: 516 },
          }}
        >
          {bodies.map(({ prefix, suffix }) => (
            <Typography key={`${id}-bodies-${prefix}`} mb={3} variant="body1">
              <b>{prefix}: </b>
              {suffix}
            </Typography>
          ))}
        </Stack>
      )}

      <Typography display="block" mb={3} variant="body1" width="516px">
        <b>{bulletHeading}</b>
      </Typography>

      {bullets && (
        <Stack
          sx={{
            maxWidth: 600,
            textAlign: "left",
            width: { sm: 312, lg: 516 },
          }}
        >
          <ul>
            {bullets.map(({ prefix, suffix }) => (
              <li key={`${id}-bullets-${prefix}`}>
                <Typography mb={3} variant="body1">
                  <b>{prefix}: </b>
                  {suffix}
                </Typography>
              </li>
            ))}
          </ul>
        </Stack>
      )}
    </Stack>
  );
}
